// Handle product card options dropdown
document.addEventListener('click', (e) => {
  // Close button click
  if (e.target.closest('.product-card__options-dropdown-close')) {
    const closeButton = e.target.closest('.product-card__options-dropdown-close');
    const dropdownId = closeButton.dataset.dropdownId;
    const dropdown = document.getElementById(dropdownId);
    
    if (dropdown) {
      dropdown.setAttribute('hidden', '');
      const toggleButton = document.querySelector(`[data-dropdown-id="${dropdownId}"]`);
      if (toggleButton && toggleButton.classList.contains('product-card__options-toggle')) {
        toggleButton.setAttribute('aria-expanded', 'false');
      }
    }
    return;
  }
  
  // Toggle dropdown
  if (e.target.closest('.product-card__options-toggle')) {
    const button = e.target.closest('.product-card__options-toggle');
    const dropdownId = button.dataset.dropdownId;
    const dropdown = document.getElementById(dropdownId);
    
    if (dropdown) {
      const isExpanded = button.getAttribute('aria-expanded') === 'true';
      
      // Close all other dropdowns
      document.querySelectorAll('.product-card__options-dropdown:not([hidden])').forEach(dd => {
        if (dd.id !== dropdownId) {
          dd.setAttribute('hidden', '');
          const otherButton = document.querySelector(`[data-dropdown-id="${dd.id}"]`);
          if (otherButton) {
            otherButton.setAttribute('aria-expanded', 'false');
          }
        }
      });
      
      if (isExpanded) {
        dropdown.setAttribute('hidden', '');
        button.setAttribute('aria-expanded', 'false');
      } else {
        dropdown.removeAttribute('hidden');
        button.setAttribute('aria-expanded', 'true');
      }
    }
  }
  
  // Handle option click - add to cart
  if (e.target.closest('.product-card__option-item')) {
    const optionItem = e.target.closest('.product-card__option-item');
    const variantId = parseInt(optionItem.dataset.variantId, 10);
    const sellingPlanId = optionItem.dataset.sellingPlan || '';
    
    if (!variantId || isNaN(variantId)) {
      console.error('Invalid variant ID');
      return;
    }
    
    // Add loading state
    optionItem.classList.add('loading');
    optionItem.disabled = true;
    
    // Prepare cart data
    const cartData = {
      items: [{
        id: variantId,
        quantity: 1
      }],
      sections: ['cart-drawer', 'header']
    };
    
    // Add selling plan if it's a subscription
    if (sellingPlanId) {
      cartData.items[0].selling_plan = parseInt(sellingPlanId, 10);
    }
    
    // Add to cart
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(cartData)
    })
    .then(response => response.json())
    .then(data => {
      if (data.status) {
        // Error
        console.error('Error adding to cart:', data.description);
        optionItem.classList.remove('loading');
        optionItem.disabled = false;
        return;
      }
      
      // Success - get updated cart
      return fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(cartData => {
          cartData.sections = data.sections;
          
          // Update cart state
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { cart: cartData }
          }));
          
          // Dispatch product added event
          document.dispatchEvent(new CustomEvent('product-ajax:added', {
            detail: { product: data }
          }));
          
          // Dispatch cart drawer refresh event
          document.dispatchEvent(new CustomEvent('cart:refresh', {
            detail: { cart: cartData }
          }));
          
          // Update cart count
          const cartCount = document.querySelector('.cart-count');
          if (cartCount) {
            cartCount.textContent = cartData.item_count;
          }
          
          // Close dropdown
          const dropdown = optionItem.closest('.product-card__options-dropdown');
          if (dropdown) {
            dropdown.setAttribute('hidden', '');
            const toggleButton = document.querySelector(`[data-dropdown-id="${dropdown.id}"]`);
            if (toggleButton) {
              toggleButton.setAttribute('aria-expanded', 'false');
            }
          }
          
          // Show cart drawer
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            cartDrawer.show(optionItem);
          }
          
          optionItem.classList.remove('loading');
          optionItem.disabled = false;
        });
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      optionItem.classList.remove('loading');
      optionItem.disabled = false;
    });
  }
});

// Close dropdown when clicking outside
document.addEventListener('click', (e) => {
  if (!e.target.closest('.product-card__actions--relative')) {
    document.querySelectorAll('.product-card__options-dropdown:not([hidden])').forEach(dropdown => {
      dropdown.setAttribute('hidden', '');
      const button = document.querySelector(`[data-dropdown-id="${dropdown.id}"]`);
      if (button) {
        button.setAttribute('aria-expanded', 'false');
      }
    });
  }
});
